<script>

import {defineComponent} from "vue";

export default defineComponent({
  name: "ManageDepartments",
  data: () => {
    return {
      deptname: '',
      deps: '',
      depSearch: '',
      editingDep: '',
      depChanges: {
        selectedChief: '',
        selectedFather: '',
        modifiedTitle: '',
      },
      selectedChiefName: '',
      selectedDepName: '',
      posChief: {},
      posFat: {},
    }
  },

  computed: {
    filteredDeps() {
      if (!this.depSearch) {
        return this.deps;
      }
      return this.deps.filter(dep => dep.title.toLowerCase().includes(this.depSearch.toLowerCase()));
    }
  },
  methods: {
    async regDept() {
      try {
        let data = {title: this.deptname}
        let result = await this.$api.post("/auth/departments", data, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        });
        if (result.status.toString() === "201") {
          this.$swal.fire({
            icon: 'success',
            title: 'Registrado',
            text: '',
            customClass: {
              popup: 'mySwal'
            }
          })
          this.deptname = ""
          await this.getDep()
        }
      } catch (error) {
        this.$swal.fire({
          icon: 'error',
          title: 'No se ha podido registrar',
          text: '',
          customClass: {
            popup: 'mySwal'
          }
        })
      }
    },
    async getDep() {
      try {
        let result = await this.$api.get("/auth/departments")
        if (result.status.toString() === "200") {
          this.deps = result.data
          for (let i = 0; i < this.deps.length; i++) {
            let temp = this.deps[i].id
            for (let j = i + 1; j < this.deps.length; j++) {
              if (temp === this.deps[j].id) {
                this.deps[i].child = this.deps[i].child + " | " + this.deps[j].child
                this.deps.splice(j, 1)
                j--
              }
            }
          }

        }
        console.log(this.deps)
      } catch (error) {
        this.$swal.fire({
          icon: 'error',
          title: '',
          text: 'No se pudo obtener informacion requerida',
          customClass: {
            popup: 'mySwal'
          }
        })
      }
    },
    editDep(dep) {
      this.posChief = []
      this.posFat = []
      this.getPosChief(dep.id)
      this.getPosFat(dep.id)
      console.log('Possible fathers')
      console.log(this.posFat)
      this.editingDep = dep
      this.depChanges.selectedChief = this.editingDep.chief
      this.depChanges.selectedFather = this.editingDep.fatherId
      this.depChanges.modifiedTitle = this.editingDep.title
      if (this.editingDep.chief === 0) {
        this.selectedChiefName = ""
      } else {
        this.selectedChiefName = this.editingDep.firstname + " " + this.editingDep.lastname
      }
      if (this.editingDep.fatherId === 0) {
        this.selectedDepName = ""
      } else {
        this.selectedDepName = this.editingDep.father
      }
    },
    async getPosFat(id) {
      try {
        let result = await this.$api.get(`/auth/departments/${id}/fathers/possibles`, {
          withCredentials: true,
        });

        if (result.status.toString() === "200") {
          this.posFat = result.data
        }

      } catch (error) {
        this.$swal.fire({
          icon: 'error',
          title: '',
          text: 'No se pudo obtener informacion requerida',
          customClass: {
            popup: 'mySwal'
          }
        })
      }
    },
    async getPosChief(id) {
      try {
        let result = await this.$api.get(`/auth/departments/${id}/chiefs/possibles`, {
          withCredentials: true,
        });

        if (result.status.toString() === "200") {
          this.posChief = result.data
          this.posChief = result.data.map(chief => ({...chief, fullname: `${chief.firstname} ${chief.lastname}`}));
        }
      } catch (error) {
        this.$swal.fire({
          icon: 'error',
          title: '',
          text: 'No se pudo obtener informacion requerida',
          customClass: {
            popup: 'mySwal'
          }
        })
      }
    },
    async modifyDep() {
      try {

        let data = {
          title: this.depChanges.modifiedTitle,
          father: this.depChanges.selectedFather,
          chief: this.depChanges.selectedChief,
        }
        let result = await this.$api.put(`/auth/departments/${this.editingDep.id}`, data, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        });

        if (result.status.toString() === "201") {
          this.$swal.fire({
            icon: 'success',
            title: 'Se han guardado los cambios',
            text: '',
            customClass: {
              popup: 'mySwal'
            }
          })
          await this.getDep()
        } else {
          this.$swal.fire({
            icon: 'error',
            title: 'No se han podido registrar los cambios',
            text: '',
            customClass: {
              popup: 'mySwal'
            }
          })
        }
      } catch (error) {
        this.$swal.fire({
          icon: 'error',
          title: 'No se han podido registrar los cambios',
          text: '',
          customClass: {
            popup: 'mySwal'
          }
        })
      }
    },
    cancelEdit() {
      this.editingDep = ''
      this.posChief = {}
      this.posFat = {}
      this.depChanges.selectedChief = ''
      this.depChanges.selectedFather = ''
      this.depChanges.modifiedTitle = ''
    },
    getIDChief() {
      let selectedItem = this.posChief.find(chief => chief.fullname === this.selectedChiefName);
      if (selectedItem !== undefined) {
        this.depChanges.selectedChief = selectedItem.id
        console.log(selectedItem.id);
      } else {
        this.depChanges.selectedChief = 0
      }
    },
    getIDDep() {
      let selectedItem = this.posFat.find(fat => fat.title === this.selectedDepName);
      if (selectedItem !== undefined) {
        this.depChanges.selectedFather = selectedItem.id
        console.log(selectedItem.id);
      } else {
        this.depChanges.selectedFather = 0
      }
    },
    inputLimiterSearch() {
      this.depSearch = this.depSearch.replace(/[^a-z0-9 ]/gi, '').trimStart();
    },
    inputLimiterName() {
      this.deptname = this.deptname.replace(/[^a-z0-9 ]/gi, '').trimStart();
    },
    inputLimiterModName() {
      this.depChanges.modifiedTitle = this.depChanges.modifiedTitle.replace(/[^a-z0-9 ]/gi, '').trimStart();
    },
    inputLimiterModChief() {
      this.selectedChiefName = this.selectedChiefName.replace(/[^a-z0-9 ]/gi, '').trimStart();
    },
    inputLimiterModDep() {
      this.selectedDepName = this.selectedDepName.replace(/[^a-z0-9 ]/gi, '').trimStart();
    },
  },
  created() {
    this.getDep()
  }
})
</script>

<template>


  <h1>Departamentos</h1>

  <div class="grid-container-left">

    <div>

      <form class="Form">
        <input type="text" v-model="depSearch" v-on:input="inputLimiterSearch"
               placeholder="Buscar departamento">
      </form>
      <div class="mt-4 table-container" v-if="filteredDeps.length">
        <table class="table table-bordered">
          <thead>
          <tr>
            <th>#</th>
            <th>Nombre</th>
            <th>Director / Jefe</th>
            <th>Dependiente de</th>
            <th>Opciones</th>

          </tr>

          </thead>
          <tbody>

          <tr v-for="(dep, index) in filteredDeps" :key="dep.id">
            <th scope="row">{{ index + 1 }}</th>
            <td>{{ dep.title }}</td>
            <td>{{ dep.firstname }} {{ dep.lastname }}</td>
            <td>{{ dep.father }}</td>
            <td class="td_align_center">
              <button class="tableBtn" @click="editDep(dep)" role="link">Editar</button>
            </td>
          </tr>

          </tbody>

        </table>
      </div>

      <div v-if="!filteredDeps.length">
        <label>No se encontraron departamentos</label>
      </div>

    </div>

    <div>
      <h2 v-if="!this.editingDep">Registrar Departamento</h2>
      <form class="Form" v-if="!this.editingDep">
        <label>Nombre</label>
        <input type="text" v-model="deptname" v-on:input="inputLimiterName"
               placeholder="Nombre del departamento">
        <button type="submit" @click.prevent="regDept">Registrar</button>
      </form>

      <h2 v-if="this.editingDep">Modificar Departamento</h2>
      <form class="Form" v-if="this.editingDep">
        <label>Nombre</label>
        <input type="text" v-model="this.depChanges.modifiedTitle" v-on:input="inputLimiterModName"
               placeholder="Nombre del departamento">
        <label>Jefe/Director</label>
        <input list="posChief" v-model="selectedChiefName" @input="getIDChief" v-on:input="inputLimiterModChief"
               placeholder="Seleccione una opcion">
        <datalist id="posChief">
          <option v-for="chief in posChief" :key="chief.id" :value="chief.fullname"></option>
        </datalist>
        <label>Dependiente de:</label>
        <input list="posFat" v-model="selectedDepName" @input="getIDDep" v-on:input="inputLimiterModDep"
               placeholder="Seleccione una opcion">
        <datalist id="posFat">
          <option v-for="fat in posFat" :key="fat.id" :value="fat.title"></option>
        </datalist>
        <button type="submit" @click.prevent="modifyDep">Guardar cambios</button>
        <button type="submit" @click.prevent="cancelEdit">Cancelar</button>
      </form>
    </div>
  </div>


</template>

<style>

.grid-container-left {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}

.grid-container-left > div:first-child {
  flex: 0 0 800px; /* the first column is 800px */
  margin: 1em;
}

.grid-container-left > div:last-child {
  flex: 0 0 400px; /* the second column is 400px */
  margin: 1em;
}

.Form label {
  width: 300px;
  text-align: left;
  display: block;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 10px;
}

.tableBtn {
  margin-bottom: 0;
}


</style>